module.exports = __webpack_public_path__ + "img/gwy.e9716530.jpg";